import moment from 'moment';
import {
  getActualDepartureCars,
  getPlanDepartureCars,
  crudRequest2,
  crudRequest
} from '@/services/api';
import { getToDay } from '@/utils/date';

const paramsForm = {
  dateRange: getToDay(),
  centerFilter: '',
  provinceArea: ''
}

export default {
  namespace: 'centerWeightView',
  state: {
    ...paramsForm,
    defualtDateFormat: 'YYYY-MM-DD HH:mm:00',

    isTmsLoading: false, // tms 接口是否加载完成
    actualDepartureCarsItem: [],  // 已发出 tms
    planDepartureCarsItem: [], // 计划发
    volumeItem: [], // 运力
    actualVolumeList: [] // 实际运力

  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/centerweightview/search')
      yield put({ type: 'centerWeightViewDepartTables/getSelect' });
    },
    *getTms(_, { call, put, select }) {
      // tms
      yield put({
        type: 'update',
        payload: { isTmsLoading: false },
      });
      let query = yield select(({ centerWeightView }) => {
        return {
          defualtDateFormat: centerWeightView.defualtDateFormat,
          locationName: centerWeightView.centerFilter,
          startTime: moment(centerWeightView.dateRange[0]).format(centerWeightView.defualtDateFormat),
          endTime: moment(centerWeightView.dateRange[1]).format(centerWeightView.defualtDateFormat),
        }
      });
      const result3 = yield call(getActualDepartureCars, query);
      const result4 = yield call(getPlanDepartureCars, {
        ...query,
        endTime: moment(query.endTime).add(1, 'days').format(query.defualtDateFormat),
      });
      const start = moment(query.startTime).day();
      const departure = yield call(crudRequest2, {
        period: start === 0 ? 7 : start,
        departureCenter: query.locationName
      });
      const actualVolumes = yield crudRequest('/api/route/volumes3', {
        startTime: query.startTime,
        endTime: query.endTime,
        departureCenter: query.locationName
      });
      const volumeItem = departure.data && departure.data.length > 0 ? departure.data : []
      const actualVolumeList = actualVolumes.data && actualVolumes.data.length > 0 ? actualVolumes.data : []
      yield put({
        type: 'update',
        payload: {
          isTmsLoading: true,
          actualDepartureCarsItem: result3.data || [],
          planDepartureCarsItem: result4.data || [],
          volumeItem: volumeItem,
          actualVolumeList
        },
      });
    }
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
